import { render } from "./Stock Take Variance.vue?vue&type=template&id=2190bf26"
import script from "./Stock Take Variance.vue?vue&type=script&lang=js"
export * from "./Stock Take Variance.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__